/* eslint-disable class-methods-use-this */
import _ from 'lodash';
import * as api from '../../../../utils/apiClient';
import {
  restructureUserDaysStatModel,
  restructureUserDaysStatTotalModel
} from './restructuring';
import { restructurePaginationModel } from '../../../../common/restructuring';

function daysStatDestructData(state, responseJson) {
  if (!responseJson.success) {
    return {
      response: responseJson,
      destructData: null
    };
  }
  return {
    response: responseJson,
    destructData: {
      itemsById: _.keyBy(
        _.map(responseJson.data.list.items, item =>
          restructureUserDaysStatModel(state, item)
        ),
        'groupDate'
      ),
      itemsIds: _.map(responseJson.data.list.items, item => item.group_date),
      pagination: restructurePaginationModel(
        _.get(responseJson, 'data.list._meta')
      ),
      total: restructureUserDaysStatTotalModel(
        state,
        _.get(responseJson, 'data.total')
      )
    }
  };
}

class UserDaysStatService {
  async getAuthUserDaysStat(state, queryParams) {
    const response = await api.get('/user-days-stat/me-v2', queryParams);
    const responseJson = await response.json();
    return daysStatDestructData(state, responseJson);
  }
  async getAuthUserReferralDaysStat(state, queryParams) {
    const response = await api.get('/user-days-stat/me-referrals', queryParams);
    const responseJson = await response.json();
    return daysStatDestructData(state, responseJson);
  }
}

export default new UserDaysStatService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userDaysStat/services/UserDaysStatService/UserDaysStatService.js